<template>
  <main>
    <MainAwards />
  </main>
</template>

<script>
const MainAwards = () => import('@/components/Awards/Main')

export default {
  components: {
    MainAwards
  },
  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>
